export class Comment {
    id: number;
    user_id: number;
    dossier_intervention_id: number;
    content: string = '';
    parent_id: number;
    created_at: string;
    updated_at: number;
    children: Comment[] = [];

    public constructor(init?: Partial<Comment>) {
        Object.assign(this, init);
    }
}
